<template>
    <div>
      <section class="box-steps">
        <div class="container">

          <div class="col-lg-3">
            <a href="#" @click.prevent="manageTab(1)">
              <div class="box-step step-1">
                <div class="number"><i class="fa fa-shopping-cart"></i></div>
                <div class="name">
                  Carro de Compras
                </div>
              </div>
            </a>
          </div>

          <div class="col-lg-3">
            <div class="box-step step-2">
              <div class="number"><i class="fa fa-paper-plane"></i></div>
              <div class="name">
                Formas de Envío
              </div>
            </div>
          </div>

          <div class="col-lg-3">
            <div class="box-step step-3">
              <div class="number"><i class="fa fa-credit-card"></i></div>
              <div class="name">Forma de Pago</div>
            </div>
          </div>

          <div class="col-lg-3">
            <div class="box-step step-4">
              <div class="number"><i class="fa fa-check"></i></div>
              <div class="name">Finalizar Compra</div>
            </div>
          </div>

        </div>

      </section>


      <section class="micarrito">

        <div class="container" >

          <div class="row" v-if="((cart_items.length>0) || (activeTab>1))">

            <div class="col-lg-8" v-if="activeTab===1">

              <div  class="box-producto-carrito" v-for="item in cart_items" :key="item.product.id">
                <div class="box-image">
                  <img :src="item.product.imageURL_M">
                </div>
                <div class="box-data">
                  <h1>{{item.product.titulo}}</h1>
                  <div class="box-cantidad">
                    <div class="lbl">Cantidad</div>

                      <div class="value">
                          <select class="" v-model="item.quantity" @change.prevent="editQuantity(item)">
                            <option :value="n" v-for="(n,index) in getTotalStockByProduct(item.product)" :key="index">{{n}} unid.</option>
                          </select>
                      </div>

                  </div>
                  <div class="box-precio">
                    <div class="lbl">Precio Unitario</div>
                    <div class="value">{{item.product.precio_mayorista | currency}} + IVA</div>
                  </div>
                  <div class="box-precio">
                    <div class="lbl">Precio Total</div>
                    <div class="value">{{item.product.precio_mayorista * item.quantity | currency}} + IVA</div>
                  </div>
                  <a  href="#" class="cartQuitar" @click.prevent="removeFromCart(item)">
                    <img src="static/img/app/btn-close-grey.svg">
                  </a>
                </div>

              </div>

            </div>

            <div class="col-lg-8" v-if="activeTab===2">

                <!-- FORMA DE ENVIO -->
                <div class="title">Formas de <span>Envío</span></div>
                <div class="copete">
                  Seleccioná una de las formas de envío disponibles <span>según los productos de tu pedido:</span>
                </div>

                <div class="box-content-options">

                  <!-- RETIRA POR SUCURSAL -->
                  <!-- <div class="box-option">
                    <label class="option">

                      <input class="forma_envio" type="radio" v-model="form_shipment.forma_envio"  value="RETIRO_SUCURSAL" checked="checked" >


                      <div class="description">
                        <strong>
                          Retiro en Gorsh Store: <div class="red-badge"><span>GRATIS</span></div>
                        </strong>
                        El Salvador 6029, Palermo, CABA, de Lunes a Sábados de 10:00 a 20:00.
                      </div>

                      <div class="clear"></div>

                    </label>
                  </div> -->

                  <!-- A CONVENIR -->
                  <div class="box-option">
                    <label class="option">

                      <input class="forma_envio" type="radio" v-model="form_shipment.forma_envio" value="CONVENIR" checked="checked"  >

                      <div class="description">
                        <strong>A convenir:</strong>
                        Nos comunicaremos a la brevedad para convenir la forma de envio.
                      </div>

                      <div class="clear"></div>

                    </label>

                  </div>

                </div>

                <div class="title">Observaciones</div>
                <div class="copete">
                  Cualquier comentario u observación sobre su pedido puede hacerlo a continuación:
                </div>

                <div class="inputForm" >
                  <textarea id="envio_observacion" v-model="form_shipment.envio_observacion" class=""></textarea>
                </div>

            </div>

            <div class="col-lg-8" v-if="activeTab==3">
              <div class="title">Formas de <span>Pago</span></div>
              <div class="copete">
                Seleccioná una de las formas de pago disponibles:
              </div>


                <div class="box-content-options">
                <div class="box-option">
                    <label class="option">

                  <input type="radio" v-model="payment_type" true-value="TR" false-value="" :value="payment_type" style="float:left;" checked="checked" >

                  <div class="description">


                    <strong>Efectivo / Depósito / Transferencia Bancaria</strong>
                    <span>A nuestra cuenta en el Banco Santander.</span>
                  </div>

                  <div class="clear"></div>

                </label>

              </div>
                </div>

            </div >

            <div class="col-lg-4" v-if="activeTab<=3">

              <div class="box-resumen-compra">
                <h1>Tu Compra <i class="fa fa-shopping-cart pull-right"></i></h1>

                  <div class="row">
                      <div class="col-xs-6">
                          <div class="lbl">Subtotal </div>
                      </div>
                      <div class="col-xs-6">
                          <div class="value">{{cart_subtotal | currency}}</div>
                      </div>
                  </div>

                  <div class="row" v-if="discount_value>0">
                      <div class="col-xs-6">
                          <div class="lbl">Descuento </div>
                      </div>
                      <div class="col-xs-6">
                          <div class="value">- ({{discount_value | currency}})</div>
                      </div>
                  </div>


                <div class="row">
                  <div class="col-xs-6">
                    <div class="lbl">IVA </div>
                  </div>
                  <div class="col-xs-6">
                    <div class="value">{{cart_total * 0.21 | currency}}</div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-xs-6">
                    <div class="lbl">Costo de envío </div>
                  </div>
                  <div class="col-xs-6">
                    <div class="value">{{ shipmentCost }}</div>
                  </div>
                </div>

                <div class="spaceline"></div>

                <div class="row">
                  <div class="col-xs-6">
                    <div class="lbl">TOTAL </div>
                  </div>
                  <div class="col-xs-6">
                    <div class="value highlight">{{cart_total + (cart_total * 0.21) | currency}}</div>
                  </div>
                </div>

                <br><br>

                <div 
                  class="btn-submit" 
                  v-if="(cart_total>=purchaseMin)" 
                  @click="continueShopping"
                  :class="{ disabled: isPurchasing && activeTab===3 }"
                >
                  <span v-if="activeTab<=2">CONTINUAR COMPRA</span>
                  <span v-else>
                    <span v-if="isPurchasing">PROCESANDO...</span>
                    <span v-else>FINALIZAR COMPRA</span>
                  </span>
                </div>
                <div v-else>
                  El minimo es {{purchaseMin | currency}} , te faltan {{ parseFloat(purchaseMin - cart_total ) | currency}}
                </div>

              </div>

            </div>

            <div class="col-lg-12" v-if="activeTab==4">

              <div class="shopMessage">
                <img src="/static/img/app/ic-ok.png" class="">
                <div class="messageContent">
                  <div class="messageTitulo">
                    Usted eligió abonar con <span class="red">depósito o transferencia bancaria.</span>
                  </div>
                  <div class="messageSubtitulo">
                    <p>
                      Por favor realice la transferencia con el importe correspondiente a su compra,
                      y luego envíe el comprobante a <a href="mailto:hola@gorsh.net">hola@gorsh.net</a> para confirmarla.
                      <br><br><br>

                      Entidad Bancaria: <strong>SANTANDER</strong><br />
                      Titular de Cuenta: <strong>GORSH SA</strong><br />
                      Tipo de cuenta: <strong>Cuenta Corriente</strong><br />
                      N&uacute;mero de cuenta: <strong>217-002934/4</strong><br />
                      Alias: <strong> GORSH-SANTANDER</strong><br />
                      CBU: <strong>0720217120000000293440</strong><br />
                      CUIT: <strong>30-71403946-2</strong>

                    </p>
                    <br><br>
                    <p>
                      Cuando la información este constatada, podrá verificarlo desde su sección
                      <router-link to="myorders" style="text-decoration:none; ">mis compras</router-link>
                    </p>
                  </div>
                </div>
              </div>

            </div>

          </div>

          <div class="row" v-if="((cart_items.length<=0)&&(activeTab<4))">
            <div class="col-lg-12">

                <div class="box-noproducts">
                    <h1>No hay productos en tu carrito.</h1>
                    <router-link to="/" class="btn-submit">COMENZAR</router-link>
                </div>

            </div>
          </div>
        </div>

      </section>
    </div>
</template>

<script>
import Api from "@/Api";
import { mapGetters } from "vuex";

export default {
    data() {
        return {
            categories: [],
            activeTab: 1,
            maxTabs: 4,
            payment_type: 1,
            form_shipment: {
                envio_observacion: "",
                forma_envio: "CONVENIR"
            },
            isPurchasing: false
        };
    },
    computed: {
        ...mapGetters([
            "user",
            "isLogged",
            "cart_total",
            "cart_subtotal",
            "discount_value",
            "cart_items",
            "purchaseMin",
            "shipment",
            "payment"
        ]),
        shipmentCost() {
            if (this.form_shipment.forma_envio === "RETIRO_SUCURSAL")
                return "Gratis";
            return "A convenir";
        }
    },
    methods: {
        manageTab(tab) {
            this.activeTab = tab;
        },
        updateTabSelected(tab) {
            $(".box-step").removeClass("active");
            $(".box-step.step-" + tab).addClass("active");
            console.log("addClass to .step-" + tab);
        },
        continueShopping() {
            // Si el usuario spamea click mientras se procesa la compra (tab 3), no hagas nada
            if (this.activeTab === 3 && this.isPurchasing) return;

            if (this.activeTab != this.maxTabs) {
                if (this.activeTab == 1) {
                    this.activeTab = this.activeTab + 1;
                    window.scrollTo(0, 0);
                    this.updateTabSelected(this.activeTab);
                } else if (this.activeTab == 2) {
                    this.$store
                        .dispatch("attachShipment", {
                            shipment: this.form_shipment
                        })
                        .then(success => {
                            this.activeTab = this.activeTab + 1;
                            window.scrollTo(0, 0);
                            this.updateTabSelected(this.activeTab);
                        });
                } else if (this.activeTab == 3) {
                    this.isPurchasing = true;

                    let cartItems = this.cart_items.map(value => {
                        return {
                            idproducto: value.product.id,
                            stock_type: "unico",
                            cantidad: value.quantity
                        };
                    });

                    let order = {
                        data: {
                            user_web_id: this.user.user_id,
                            forma_envio: this.shipment.forma_envio,
                            envio_observacion: this.shipment.envio_observacion,
                            forma_pago: this.payment,
                            discount_value: this.discount_value
                        },
                        products: cartItems
                    };

                    this.$store
                        .dispatch("processCartPurchase", { order: order })
                        .then(success => {
                            console.log(order);
                            this.activeTab = this.activeTab + 1;
                            window.scrollTo(0, 0);
                            this.updateTabSelected(this.activeTab);
                        })
                        .catch(err => {
                            this.$swal({
                                title: "Error",
                                text: err,
                                type: "warning"
                            }).then(result => {});
                        })
                        .finally(() => {
                            // Si la compra fue OK pasás a tab 4, igual ya no hay botón.
                            // Pero si falló, esto es clave para reintentar.
                            this.isPurchasing = false;
                        });
                }
            }
        },
        getTotalStockByProduct(product) {
            return parseInt(product.stock_unico);
        },
        editQuantity(item) {
            this.$store
                .dispatch("editCartQuantity", {
                    bindItem: item,
                    quantity: item.quantity
                })
                .then(success => {});
        },
        removeFromCart(item) {
            this.$store.dispatch("removeFromCart", { item }).then(success => {
                /* this.$toasted.show("Item " + item.product.titulo + " removido ", {
            theme: "bubble",
            position: "top-right",
            duration : 5000,
            action : {
              text : 'Deshacer',
              onClick : (e, toastObject) => {
                var product = item.product;
                var quantity = item.quantity;
                this.$store.dispatch("addToCart", {product,quantity}).then( product =>{
                  toastObject.goAway(0);
                });

              }
            }
          }); */

                if (this.cart_items.length <= 0) {
                    $("nav.micarrito, .overlay-micarrito").removeClass("open");
                    $("body").removeClass("lock");
                }
            });
        }
    },
    mounted() {
        //this.form_shipment = this.shipment;
        window.scrollTo(0, 0);
        this.updateTabSelected(1);
    }
};
</script>

<style scoped>
.inputForm {
    padding-bottom: 50px;
}
.btn-submit.disabled {
    pointer-events: none;
    opacity: 0.6;
    cursor: not-allowed;
}
</style>



// WEBPACK FOOTER //
// src/components/CarritoPage.vue